import { render, staticRenderFns } from "./CAxACOxBehavioralPage.vue?vue&type=template&id=0a2718e3"
import script from "./CAxACOxBehavioralPage.vue?vue&type=script&lang=js"
export * from "./CAxACOxBehavioralPage.vue?vue&type=script&lang=js"
import style0 from "./CAxACOxBehavioralPage.vue?vue&type=style&index=0&id=0a2718e3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports